export default __webpack_public_path__ + "static/media/dots.c351d81f.svg";